<template>
    <div class="form-group">
        <label v-if="hasLabel">{{ label }}</label>
        <el-select
            class="select-primary"
            size="large"
            :placeholder="placeholder"
            :clearable="clearable"
            :disabled="disabled || sortedOptions.length == 0"
            v-model="castedValue">

            <el-option
                v-for="option in sortedOptions" :key="option.key"
                class="select-primary"
                :value="option.key"
                :label="option.label">
            </el-option>
        </el-select>
    </div>
</template>

<script>
    export default {

        props: {
            value: {
                required: true
            },
            options: {
                type: Object,
                required: true
            },
            label: {
                type: String,
                default: null
            },
            placeholder: {
                type: String,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            clearable: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                castedValue: null
            }
        },

        computed: {

            hasLabel() {
                return this.label !== null
            },

            sortedOptions() {
                let sorted = []
                for (let [key, label] of Object.entries(this.options)) {
                    sorted.push({ key, label })
                }
                sorted.sort((a, b) => a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1)
                return sorted
            }
        },

        created() {
            this.castedValue = this.value === null ? null : String(this.value)
        },

        watch: {
            value(newVal) {
                this.castedValue = newVal === null ? null : String(newVal)
            },
            castedValue(newVal) {
                this.$emit('input', newVal)
            }
        }
    }
</script>

<style scoped>

    .form-group >>> .el-input.is-disabled .el-input__inner {
        border-color: #2b3553 !important;
        cursor: not-allowed !important;
    }
    .form-group >>> .el-input.is-disabled .el-input__inner::placeholder {
        color: rgba(255, 255, 255, 0.3) !important;
    }
    .form-group >>> .el-input.is-disabled .el-input__icon {
        color: #2b3553 !important;
    }

</style>